import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaInicioOrientacaoTCC = (): TabelaColuna => ({
  Chave: 'inicioOrientacaoTCC',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.inicioOrientacaoTCC)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Início Orient. TCC</div>
})
